import React from 'react';
import { Button } from './ui/Button';
import { motion } from 'framer-motion';
import { CheckCircle2, ArrowRight } from 'lucide-react';
export function HeroSection() {
  return <div className="relative bg-[#1B4332] text-white overflow-hidden pt-14 pb-10 px-4 md:px-8" data-id="element-76">
      {/* Background Pattern Overlay */}
      <div className="absolute inset-0 opacity-10 bg-[url('https://www.transparenttextures.com/patterns/paper.png')] pointer-events-none" data-id="element-77" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-78">
        {/* Top: Label + Headline */}
        <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="text-center space-y-6" data-id="element-79">
          <div className="inline-block px-4 py-1.5 rounded-full border border-[#C9963A]/50 bg-[#C9963A]/10 text-[#C9963A] text-sm font-medium tracking-wide uppercase" data-id="element-80">
            Botiquín Natural Responsable
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold leading-tight text-[#FDF8F0]" data-id="element-81">
            Qué hago hoy <br data-id="element-82" />
            <span className="text-[#C9963A] italic" data-id="element-83">
              (y cuándo voy al médico)
            </span>
          </h1>
        </motion.div>

        {/* Image — right above the subheadline */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2,
        ease: 'easeOut'
      }} className="relative my-6 max-w-2xl mx-auto" data-id="element-84">
          <div className="relative rounded-2xl overflow-hidden shadow-2xl border-4 border-[#FDF8F0]/10" data-id="element-85">
            <img src="https://cdn.magicpatterns.com/uploads/6VUKyjegT3UrtFKdqNQjee/imagen_botiquin_natural.png" alt="Botiquín Natural Responsable en dispositivos" className="w-full h-auto object-cover" data-id="element-86" />
            <div className="absolute inset-0 bg-gradient-to-t from-[#1B4332]/40 to-transparent mix-blend-multiply pointer-events-none" data-id="element-87" />
          </div>

          {/* Floating Badge */}
          <motion.div initial={{
          y: 20,
          opacity: 0
        }} animate={{
          y: 0,
          opacity: 1
        }} transition={{
          delay: 1,
          duration: 0.5
        }} className="absolute -bottom-5 -left-4 md:-bottom-6 md:-left-6 bg-[#FDF8F0] text-[#1B4332] p-4 rounded-lg shadow-xl max-w-[200px] hidden md:block" data-id="element-88">
            <p className="font-serif font-bold text-lg leading-tight" data-id="element-89">
              Sistema Doble Capa™
            </p>
            <p className="text-xs mt-1 text-gray-600" data-id="element-90">
              Seguridad clínica + Alivio natural
            </p>
          </motion.div>
        </motion.div>

        {/* Subheadline + Features + CTA */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4,
        ease: 'easeOut'
      }} className="text-center space-y-5" data-id="element-91">
          <p className="text-lg md:text-xl text-gray-200 leading-relaxed max-w-2xl mx-auto" data-id="element-92">
            Guía práctica por síntoma para aliviar molestias comunes con
            ingredientes accesibles — sin jugar al médico.
          </p>

          <div className="inline-flex flex-col sm:flex-row gap-4 sm:gap-8 text-left" data-id="element-93">
            <div className="flex items-center gap-3 text-gray-200" data-id="element-94">
              <CheckCircle2 className="text-[#C9963A] w-5 h-5 flex-shrink-0" data-id="element-95" />
              <span data-id="element-96">Fichas imprimibles "Me pasa esto → hago esto"</span>
            </div>
            <div className="flex items-center gap-3 text-gray-200" data-id="element-97">
              <CheckCircle2 className="text-[#C9963A] w-5 h-5 flex-shrink-0" data-id="element-98" />
              <span data-id="element-99">Semáforo de riesgo (Verde / Amarillo / Rojo)</span>
            </div>
          </div>

          <div className="pt-2" data-id="element-100">
            <Button size="lg" className="text-lg shadow-xl shadow-[#C9963A]/20" onClick={() => window.open('https://factorclaro.com/cart/45270142386355:1', '_self')} data-id="element-101">
              QUIERO MI BOTIQUÍN RESPONSABLE
              <ArrowRight className="ml-2 w-5 h-5" data-id="element-102" />
            </Button>
          </div>

          <p className="text-sm text-gray-400 italic" data-id="element-103">
            *Descarga digital inmediata. Acceso de por vida.
          </p>
        </motion.div>
      </div>
    </div>;
}